/* eslint-disable */
import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";
import { assetImages } from "constants";

// import url and gateway methods
import * as url from "helper/UrlHelper";
import { getData, uploadMultipleFile, postData, putData } from "utils/Gateway";

// import common components
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const statusOptions = [
  { label: "In Progress", value: "In Progress" },
  { label: "Completed", value: "Completed" },
];

const priorityOptions = [
  { label: "Low", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
  { label: "Urgent", value: "Urgent" },
];

// Dummy Study Type options, replace with API if needed
const studyTypeOptions = [
  { label: "MRI", value: "MRI" },
  { label: "CT Scan", value: "CT Scan" },
  { label: "Ultrasound", value: "Ultrasound" },
  { label: "X-Ray", value: "X-Ray" },
];

// Example body part options, replace with API if needed
const bodyPartOptions = [
  { label: "Head", value: "Head" },
  { label: "Chest", value: "Chest" },
  { label: "Abdomen", value: "Abdomen" },
  { label: "Spine", value: "Spine" },
  { label: "Limbs", value: "Limbs" },
];

const SaveDiagnosticImagingPopup = ({
  selectedImagingId,
  setSelectedImagingId,
  afterActionClose,
  patientObj = null,
  doctorObj = null,
  clinicObj = null,
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [studyName, setStudyName] = useState("");
  const [studyType, setStudyType] = useState(null);
  const [studyTypeName, setStudyTypeName] = useState("");
  const [patient, setPatient] = useState(null);
  const [doctor, setDoctor] = useState(null);
  const [clinic, setClinic] = useState(null);
  const [status, setStatus] = useState(null);
  const [priority, setPriority] = useState(null);
  const [scheduledDate, setScheduledDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]); // Array of uploaded file objects
  const [bodyPart, setBodyPart] = useState(null);
  const [bodyPartName, setBodyPartName] = useState("");
  const [isConsent, setIsConsent] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const loadPatientOptions = async (inputValue) => {
    const token = localStorage.getItem("token");
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=PATIENT`;
      const response = await getData(requestUrl);
      return response.data;
    } catch {
      return [];
    }
  };

  const loadDoctorOptions = async (inputValue) => {
    const token = localStorage.getItem("token");
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=DOCTOR`;
      const response = await getData(requestUrl);
      return response.data;
    } catch {
      return [];
    }
  };

  const loadClinicOptions = async (inputValue) => {
    const token = localStorage.getItem("token");
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${inputValue}&filtertypeslug=LABORATORY`;
      const response = await getData(requestUrl);
      return response.data;
    } catch {
      return [];
    }
  };

  //function for file upload (multiple)
  const uploadHandler = async (files) => {
    try {
      setDocFileUploading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, files);
      //check response status is true or not.If true then assign uploaded files with path for display
      if (response.status) {
        setUploadedFiles((prev) => [...prev, ...response.data]);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setDocFileUploading(false);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  //function for get diagnostic imaging details
  const getImagingDetails = async () => {
    try {
      setIsLoadingDetails(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_DIAGNOSTIC_IMAGING_DETAILS +
        `/${selectedImagingId}?token=${token}`;

      console.log("requestUrl in get diagnostic imaging details", requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        const imagingData = response.data;

        setStudyName(imagingData.name);
        setStudyTypeName(imagingData.type);
        setBodyPartName(imagingData.bodypart);
        setStatus({
          value: imagingData.diagnosisstatus,
          label: imagingData.diagnosisstatus,
        });
        setPriority({
          value: imagingData.priority,
          label: imagingData.priority,
        });
        setScheduledDate(
          imagingData.scheduledDate
            ? new Date(imagingData.scheduledDate).toISOString().split("T")[0]
            : ""
        );
        setAdditionalNotes(imagingData.additionalinfo);
        setIsConsent(imagingData.isconsent);

        if (
          imagingData.uploadedfiles &&
          Array.isArray(imagingData.uploadedfiles)
        ) {
          setUploadedFiles(imagingData.uploadedfiles);
        }

        if (imagingData.assignedtovalue) {
          setPatient({
            value: imagingData.assignedtovalue,
            label: imagingData.assignedtolabel,
          });
        }
        if (imagingData.doctorvalue) {
          setDoctor({
            value: imagingData.doctorvalue,
            label: imagingData.doctorlabel,
          });
        }
        if (imagingData.clinicvalue) {
          setClinic({
            value: imagingData.clinicvalue,
            label: imagingData.cliniclabel,
          });
        }
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoadingDetails(false);
    }
  };

  // Save handler
  const saveHandler = async () => {
    try {
      setIsSaving(true);

      const apiData = {
        istemplate: false,
        name: studyName,
        type: studyTypeName,
        bodypart: bodyPartName,
        diagnosisstatus: status?.value,
        assignto: patient ? patient.value : null,
        doctorid: doctor ? doctor.value : null,
        clinicid: clinic ? clinic.value : null,
        uploadids: uploadedFiles.map((f) => f._id),
        priority: priority?.value,
        scheduledDate: new Date(scheduledDate),
        additionalinfo: additionalNotes,
        isconsent: isConsent,
      };

      console.log("apiData", apiData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedImagingId) {
        requestUrl +=
          url.API_UPDATE_DIAGNOSTIC_IMAGING +
          `/${selectedImagingId}?token=${token}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_DIAGNOSTIC_IMAGING + `?token=${token}`;
        response = await postData(requestUrl, apiData);
      }

      console.log("response in save diagnostic imaging", response);

      if (response.status) {
        resetHandler();
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveDiagnosticImagingOffCanvas")
        ).hide();
        afterActionClose([response.data]);
      }

      setIsSaving(false);
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  // Reset handler
  const resetHandler = () => {
    setStudyName("");
    setStudyType(null);
    setStudyTypeName("");
    setPatient(patientObj);
    setDoctor(doctorObj);
    setClinic(clinicObj);
    setStatus(null);
    setPriority(null);
    setScheduledDate(new Date().toISOString().split("T")[0]);
    setAdditionalNotes("");
    setUploadedFiles([]);
    setBodyPart(null);
    setBodyPartName("");
    setSelectedImagingId(null);
    setIsConsent(false);
  };

  useEffect(() => {
    if (selectedImagingId) {
      getImagingDetails();
    }
  }, [selectedImagingId]);

  useEffect(() => {
    if (patientObj && !selectedImagingId) {
      setPatient(patientObj);
    }
  }, [patientObj, selectedImagingId]);

  useEffect(() => {
    if (doctorObj && !selectedImagingId) {
      setDoctor(doctorObj);
    }
  }, [doctorObj, selectedImagingId]);

  useEffect(() => {
    if (clinicObj && !selectedImagingId) {
      setClinic(clinicObj);
    }
  }, [clinicObj, selectedImagingId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveDiagnosticImagingOffCanvas"
      aria-labelledby="saveDiagnosticImagingOffCanvas"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              medical_information
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              {t("Save Diagnostic Imaging")}
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update diagnostic imaging details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {isLoadingDetails ? (
          <div className="d-flex flex-column align-items-center justify-content-center py-5">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="fw-semibold text-primary">Loading details...</div>
          </div>
        ) : (
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-white">
              {/* Section 1: Associated Persons */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="mb-3 fw-semibold">Associated Persons</h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Patient <span className="text-danger">*</span>
                    </label>
                    <AsyncSelect
                      loadOptions={loadPatientOptions}
                      value={patient}
                      onChange={setPatient}
                      isClearable
                      placeholder="Search or select patient..."
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                    {patient ? (
                      <div className="patient-details mt-3 p-3 border border-gray-300 rounded-8 shadow-sm">
                        {/* Patient details */}
                        <div className="d-flex gap-3">
                          <div
                            className="avatar rounded-circle overflow-hidden"
                            style={{
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <img
                              className="w-100 h-100 object-fit-cover"
                              src={
                                patient?.image !== ""
                                  ? url.SERVER_URL + patient?.image
                                  : assetImages.defaultUser
                              }
                              alt="patient"
                            />
                          </div>
                          <div>
                            <p className="mb-0">{patient?.label}</p>
                            <p className="font-sm text-gray mb-1">
                              Patient Email: {patient?.email}
                            </p>
                          </div>
                        </div>
                        {/* Calendar details for patient */}
                        <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                          <p className="fw-semibold mb-2">
                            Information for {patient?.label}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            Phone: {patient?.phone}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            City: {patient?.city}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            State: {patient?.state}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            Country: {patient?.country}
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Doctor <span className="text-danger">*</span>
                    </label>
                    <AsyncSelect
                      loadOptions={loadDoctorOptions}
                      value={doctor}
                      onChange={setDoctor}
                      isClearable
                      placeholder="Search or select doctor..."
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                    {doctor ? (
                      <div className="patient-details mt-3 p-3 border border-gray-300 rounded-8 shadow-sm">
                        {/* Patient details */}
                        <div className="d-flex gap-3">
                          <div
                            className="avatar rounded-circle overflow-hidden"
                            style={{
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <img
                              className="w-100 h-100 object-fit-cover"
                              src={
                                doctor?.image !== ""
                                  ? url.SERVER_URL + doctor?.image
                                  : assetImages.defaultUser
                              }
                              alt="patient"
                            />
                          </div>
                          <div>
                            <p className="mb-0">{doctor?.label}</p>
                            <p className="font-sm text-gray mb-1">
                              Doctor Email: {doctor?.email}
                            </p>
                          </div>
                        </div>
                        {/* Calendar details for patient */}
                        <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                          <p className="fw-semibold mb-2">
                            Information for {doctor?.label}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            Phone: {doctor?.phone}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            City: {doctor?.city}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            State: {doctor?.state}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            Country: {doctor?.country}
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Clinic
                    </label>
                    <AsyncSelect
                      loadOptions={loadClinicOptions}
                      value={clinic}
                      onChange={setClinic}
                      isClearable
                      placeholder="Search or select clinic..."
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                    {clinic ? (
                      <div className="clinic-details mt-3 p-3 border border-gray-300 rounded-8 shadow-sm">
                        {/* Clinic details */}
                        <div className="d-flex gap-3">
                          <div
                            className="avatar rounded-circle overflow-hidden"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <img
                              className="w-100 h-100 object-fit-cover"
                              src={
                                clinic?.logopath !== ""
                                  ? url.SERVER_URL + clinic?.logopath
                                  : assetImages.defaultUser
                              }
                              alt="clinic"
                            />
                          </div>
                          <div>
                            <p className="mb-0">{clinic?.label}</p>
                            <p className="font-sm text-gray mb-1">
                              Owner: {clinic?.moderatorname}
                            </p>
                          </div>
                        </div>
                        <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                          <p className="fw-semibold mb-2">
                            Information for Clinic {clinic?.label}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            Phone: {clinic?.phone}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            City: {clinic?.city}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            State: {clinic?.state}
                          </p>
                          <p className="font-sm text-gray mb-1">
                            Country: {clinic?.country}
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="form-check mt-2 d-flex gap-1 align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isconsent"
                    checked={isConsent}
                    onChange={(e) => setIsConsent(e.target.checked)}
                  />
                  <label
                    className="form-check-label fw-semibold"
                    htmlFor="isconsent"
                  >
                    Patient consent
                  </label>
                </div>
              </div>

              {/* Section 2: Study & Body Part Details */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="mb-3 fw-semibold">Study & Body Part Details</h5>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Study Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      value={studyName}
                      onChange={(e) => setStudyName(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="E.g., MRI of Head, CT Scan of Chest, etc."
                      required
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Study Type
                    </label>
                    <Select
                      options={studyTypeOptions}
                      value={studyType}
                      onChange={(val) => {
                        if (val) {
                          setStudyType(val);
                          setStudyTypeName(val.label);
                        } else {
                          setStudyType(null);
                          setStudyTypeName("");
                        }
                      }}
                      isClearable
                      placeholder="Select Study Type"
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Study Type Name (If Not in the List){" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      value={studyTypeName}
                      onChange={(e) => setStudyTypeName(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter Study Type Name"
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Body Part
                    </label>
                    <Select
                      options={bodyPartOptions}
                      value={bodyPart}
                      onChange={(val) => {
                        if (val) {
                          setBodyPart(val);
                          setBodyPartName(val.label);
                        } else {
                          setBodyPart(null);
                          setBodyPartName("");
                        }
                      }}
                      isClearable
                      placeholder="Select Body Part"
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Body Part Name (If Not in the List){" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      value={bodyPartName}
                      onChange={(e) => setBodyPartName(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter Body Part Name"
                    />
                  </div>
                </div>
              </div>

              {/* Section 3: Imaging Meta Data */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="mb-3 fw-semibold">Imaging Meta Data</h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Priority
                    </label>
                    <Select
                      options={priorityOptions}
                      value={priority}
                      onChange={setPriority}
                      isClearable
                      placeholder="Select Priority"
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Status
                    </label>
                    <Select
                      options={statusOptions}
                      value={status}
                      onChange={setStatus}
                      isClearable
                      placeholder="Select Status"
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                </div>
              </div>

              {/* Section 4: Schedule & Notes */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="mb-3 fw-semibold">Schedule & Notes</h5>
                <div className="mb-3">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Scheduled Date
                  </label>
                  <input
                    type="date"
                    value={scheduledDate}
                    onChange={(e) => setScheduledDate(e.target.value)}
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Select Scheduled Date"
                  />
                </div>
                <div className="mb-3">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Additional Notes
                  </label>
                  <textarea
                    rows="3"
                    value={additionalNotes}
                    onChange={(e) => setAdditionalNotes(e.target.value)}
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Enter additional notes"
                  />
                </div>
              </div>

              {/* Section 5: Attachments */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="mb-3 fw-semibold">Attachments</h5>
                <FileUploadField
                  label={t("Upload Documents")}
                  accept="doc mp4 pdf txt xls"
                  onUpload={uploadHandler}
                  files={uploadedFiles.map((file) => ({
                    path: url.SERVER_URL + file.path,
                    name: file.name,
                  }))}
                  onRemove={closeDocFileHandler}
                  loading={docFileUploading}
                  multiple={true}
                  fileType="document"
                />
              </div>

              {/* Action Button */}
              <div className="group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  onClick={saveHandler}
                  disabled={isSaving}
                  style={{
                    cursor: isSaving ? "not-allowed" : "pointer",
                  }}
                >
                  {isSaving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <span className="material-symbols-outlined me-1">
                        save
                      </span>
                      Save Diagnostic Imaging
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SaveDiagnosticImagingPopup;
